import TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './imageViewer.html?raw';
class imageViewer extends compose(TabEnabledMixin) {
    templateString: any = template;

    private imageContainer:HTMLDivElement;
    private imageElem:HTMLImageElement;
    
    private widgetRootContainer:HTMLDivElement;

    /**
     * wird auf `true` gesetzt wenn das Bild geladen wurde.
     */
    public isReady = false;

    /**
     * Aktuelles Offset vom Bild.
     * Default ist x,y=0 & scale=1.0
     */
    public currentOffset: {x:number, y:number, scale:number} = {
        x:0,
        y:0,
        scale:1.0,
    };

    /**
     * Wie schnell Zoom & Verschieben pro "click" ist.
     */
    public speedModifier: {xy:number, scale:number} = {
        xy:4,
        scale:0.05,
    };
    postCreate(): void {
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    /**
     * @param base64Image Image Datei als Base64
     * @param filetype Datei-Typ als Lowercase und ohne "."!
     * @param altTxt Alternativer Text fuer Screenreader
     */
    public loadImageFromBase64(base64Image: string, filetype: 'png' | 'jpg' | 'jpeg' |'gif'|string, altTxt=null){
        //theoretisch funktioniert jeder filetype der als <img> dargestellt werden kann...
        this.widgetRootContainer.classList.remove("w3-hide");
        let img = base64Image;
        let dataStr = "data:image/" + filetype + ";base64,";
        if (img.indexOf(dataStr) == -1){
            img = dataStr + img;
        }

        this.imageElem.src = img;
        if (altTxt != null){
            if (typeof altTxt == 'string'){
                this.imageElem.alt = altTxt;
            }
        }

        if (this.imageElem.complete){
            this.onImageReady();
        }else{
            this.imageElem.addEventListener('load', lang.hitch(this, this.onImageReady));
        }
    }

    private onImageReady(){
        this.resetTransformation();
        this.widgetRootContainer.tabIndex = 0; //elem ist tab-able
        //keyboard events
        this.widgetRootContainer.addEventListener("keydown", lang.hitch(this, this._onHandle_KeyDown))
        this.widgetRootContainer.addEventListener('wheel', lang.hitch(this, this._onHandle_MouseWheel));

        this.emit("ready");
        this.isReady = true;
    }

    public resetTransformation(){
        this.currentOffset = { //reset
            x: 0,
            y: 0,
            scale: 1.0,
        };
        this.renderTransform();
    }

    private renderTransform(){
        if (this.currentOffset.scale < 0.01){
            this.currentOffset.scale = 0.01;
        }
        let cssStr = "";
        cssStr+= "scale(" + this.currentOffset.scale + ")";
        cssStr+= " translateX(" + this.currentOffset.x + "px)";
        cssStr+= " translateY(" + this.currentOffset.y + "px)";
        this.imageElem.style.transform = cssStr;
    }

    private _onHandle_CLickZoomMinus(){
        this.currentOffset.scale = this.currentOffset.scale - this.speedModifier.scale;
        this.renderTransform();
    }
    private _onHandle_CLickZoomPlus(){
        this.currentOffset.scale = this.currentOffset.scale + this.speedModifier.scale;
        this.renderTransform();
    }

    private _onHandle_KeyDown(ev:KeyboardEvent){
        if (ev.ctrlKey){
            switch (ev.key) {
                case 'ArrowUp':
                    this.currentOffset.scale = this.currentOffset.scale + this.speedModifier.scale;
                    break;
                case 'ArrowDown':
                    this.currentOffset.scale = this.currentOffset.scale - this.speedModifier.scale;
                    break;
            }
        }else{
            switch (ev.key){
                case 'ArrowUp':
                    this.currentOffset.y = this.currentOffset.y - this.speedModifier.xy;
                    break;
                case 'ArrowDown':
                    this.currentOffset.y = this.currentOffset.y + this.speedModifier.xy;
                    break;
                case 'ArrowLeft':
                    this.currentOffset.x = this.currentOffset.x - this.speedModifier.xy;
                    break;
                case 'ArrowRight':
                    this.currentOffset.x = this.currentOffset.x + this.speedModifier.xy;
                    break;
            }
        }
        if (ev.key == 'Escape'){
            this.resetTransformation();
        }else{
            this.renderTransform();
        }
        if (ev.key != "F5"){
            ev.preventDefault();
        }
    }

    private _onHandle_MouseWheel(ev:WheelEvent){
        if (ev.ctrlKey){
            if (ev.deltaY < 0){
                this.currentOffset.scale = this.currentOffset.scale + this.speedModifier.scale;
            }else{
                this.currentOffset.scale = this.currentOffset.scale - this.speedModifier.scale;
            }
            this.renderTransform();
            ev.preventDefault();
        }
    }
}

export default mdsWidget(imageViewer);
